// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_URi","cls2":"ReferenceCard-cls2_4KG ReferenceCard-cls1_URi"};